import { history } from 'umi';

// datalab页面，登录态失效，标识
export const getTokenFailureUrlValid = ()=> {
  const urlArray = history.location.pathname.split('/') as Array<string>;
  if (urlArray?.length < 2) {
    return false;
  }
  const secondParam = urlArray?.[1];
  const lastParam = urlArray?.[urlArray?.length - 1];
  const validStates =  secondParam === 'datalab' &&
    (lastParam === 'MultiAnalysis' || lastParam === 'CreateDashboard');
  if (validStates) {
    window.sessionStorage.setItem('isUserFailure', JSON.stringify(true));
  }
};

export const getTokenFailureKey = ()=>{
  const key = window.sessionStorage.getItem('datalabChartsCatch');
  try {
    return JSON.parse(key || '{}');
  } catch (e) {
    return null;
  }
};